export type SupportedCurrency = 'BTC' | 'LTC'

export const SUPPORTED_CURRENCIES = ['BTC', 'LTC'] as const

export const DEFAULT_CURRENCY: SupportedCurrency = 'BTC'

export interface CurrencyOption {
  value: SupportedCurrency
  label: string
  icon: any // Vue component
}

export interface CurrencyState {
  selectedCurrency: SupportedCurrency
  isMultiCurrencyEnabled: boolean
} 